module.exports = __webpack_public_path__ + "img/building_bg.5c48221c.png";